import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { UserLogDTO } from '../../../api/user-log-api';
import { UserDTO } from '../../../api/user-api';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { FormikCellToggle, FormikDateInput, FormikNumberInput, FormikTextField } from '../../../components/formik';
import { yup } from '../../../components/basic/yup';
import SvgSave from '../../../assets/icons/Save';
import SvgDelete from '../../../assets/icons/Delete';
import SvgClose from '../../../assets/icons/Close';

interface SaveUserLogModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedUserLog?: UserLogDTO;
    users:UserDTO[];
    onHide: () => void;
    onSave: (values: UserLogDTO) => void;
    onDelete?: (userLog: UserLogDTO) => void;
}

export function SaveUserLogModal({
    show,
    allowEdit,
    selectedUserLog,
    users,
    onHide,
    onSave,
    onDelete
}: SaveUserLogModalProps) {
    const UserLogSchema = yup.object().shape({
        form: yup.string(),
        action: yup.string(),
        message: yup.string(),
        url: yup.string(),
        sessionId: yup.number().required(' '),
        userName: yup.string(),
        isHistoryLog: yup.boolean().required(' '),
    });

    const defaultValues: UserLogDTO = {
        serial:selectedUserLog?.serial,
        
        form: selectedUserLog ? selectedUserLog.form :''
        ,
        
        
        action: selectedUserLog ? selectedUserLog.action :''
        ,
        
        
        message: selectedUserLog ? selectedUserLog.message :''
        ,
        
        
        url: selectedUserLog ? selectedUserLog.url :''
        ,
        
        
        sessionId: selectedUserLog ? selectedUserLog.sessionId :0
        ,
        
        
        userName: selectedUserLog ? selectedUserLog.userName :''
        ,
        
        
        isHistoryLog: selectedUserLog ? selectedUserLog.isHistoryLog :true
        ,
        
        
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={ UserLogSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedUserLog ? 'edit-user-log' : 'new-user-log'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedUserLog && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedUserLog)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    disabled={!allowEdit}
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }>
                    <Form>
                        <bd.Flex align="center" wrap>
                                <FormikTextField
                                    label="form"
                                    name="form"
                                    readOnly={!allowEdit}
                                    width="11rem"
                                    handleEnter
                                />

                                <FormikTextField
                                    label="action"
                                    name="action"
                                    readOnly={!allowEdit}
                                    width="11rem"
                                    handleEnter
                                />

                                <FormikTextField
                                    label="message"
                                    name="message"
                                    readOnly={!allowEdit}
                                    width="11rem"
                                    handleEnter
                                />

                                <FormikTextField
                                    label="url"
                                    name="url"
                                    readOnly={!allowEdit}
                                    width="11rem"
                                    handleEnter
                                />

                               <FormikTextField
                                    label="session-id"
                                    name="sessionId"
                                    readOnly={!allowEdit}
                                    width="11rem"
                                    handleEnter
                                />

                                <FormikTextField
                                    label="user-name"
                                    name="userName"
                                    readOnly={!allowEdit}
                                    type="select"
                                    items={[
                                        { id: null, title: '' },
                                        ...users.map(user => ({
                                            id: user.userName,
                                            title: `${user.firstName} ${user.lastName} `,
                                        })),
                                    ]}
                                    width="11rem"
                                    handleEnter
                                />

                                <FormikCellToggle 
                                label={<T>is-history-log</T>}
                                name="isHistoryLog"
                                readOnly={!allowEdit}  
                                />

                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
